var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.testimonials.length && _vm.data.showTestimonials)?_c('div',[_c('Testimonial',{attrs:{"title":_vm.title,"theme":_vm.data.themeType,"images":_vm.data.testimonials,"templateType":_vm.data.templateType}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }